module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"chart-type:type-1":"Linear","chart-type:type-2":"Bar","chart-type:type-3":"Bar-X","chart-type:type-4":"Pie"},"en":{"chart-type:type-1":"Linear","chart-type:type-2":"Bar","chart-type:type-3":"Bar-X","chart-type:type-4":"Pie"}}')
  delete Component.options._Ctor
}
